import { Control, FieldErrors } from 'react-hook-form'
import PasswordField from './index'

interface PasswordWithConfirmationProps {
  control: Control<any>
  errors: FieldErrors<any>
  disabled?: boolean
  passwordFieldName?: string
  confirmFieldName?: string
  passwordLabel?: string
  confirmLabel?: string
  fullWidth?: boolean
  margin?: 'none' | 'dense' | 'normal'
}

export default function PasswordWithConfirmation({
  control,
  errors,
  disabled = false,
  passwordFieldName = 'newPassword',
  confirmFieldName = 'confirmPassword',
  passwordLabel = 'New Password',
  confirmLabel = 'Confirm New Password',
  fullWidth = true,
  margin = 'normal',
}: PasswordWithConfirmationProps) {
  return (
    <>
      <PasswordField
        name={passwordFieldName}
        label={passwordLabel}
        control={control}
        errors={errors}
        disabled={disabled}
        fullWidth={fullWidth}
        margin={margin}
      />
      <PasswordField
        name={confirmFieldName}
        label={confirmLabel}
        control={control}
        errors={errors}
        disabled={disabled}
        fullWidth={fullWidth}
        margin={margin}
      />
    </>
  )
}